import { cn } from 'designSystem/lib/utils'
import { ArrowLeftToLine, ArrowRightFromLine } from 'lucide-react'
import React from 'react'

import { useSidebar } from './Sidebar'

export const SidebarCollapseToggle: React.FC<
  Omit<React.ComponentProps<'button'>, 'children'>
> = ({ className, ...props }) => {
  const { toggleSidebar, state } = useSidebar()
  const isCollapsed = state === 'collapsed'

  return (
    <button
      type='button'
      onClick={toggleSidebar}
      aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      className={cn(
        'flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-md border-none bg-transparent p-0 text-sidebar-foreground/50 transition-colors hover:text-sidebar-foreground',
        className
      )}
      {...props}>
      {isCollapsed ? (
        <ArrowRightFromLine className='size-4' />
      ) : (
        <ArrowLeftToLine className='size-4' />
      )}
    </button>
  )
}
